export function getBaseUrlAndQuery(path: string | undefined | null) {
  const [baseUrl, query] = path?.split("?") ?? [];

  return {
    baseUrl: baseUrl?.split("#")[0],
    query,
  };
}
